import { motion, useSpring, useTransform } from "motion/react"
import { useEffect } from "react"

import { empty } from "../constants/placeholders"
import { budgetFormat } from "../utils/number/budget-format.ts"

interface BudgetCountUpProps {
  value: number | null
  currency?: string
  duration?: number
}

export const BudgetCountUp = ({
  value,
  currency = "USD",
  duration = 1
}: BudgetCountUpProps) => {
  const spring = useSpring(0, { duration: duration * 1000 })

  const display = useTransform(spring, (val) => {
    return budgetFormat(val, {
      currency,
      maximumFractionDigits: 1,
      notation: "compact"
    })
  })

  useEffect(() => {
    spring.set(value ?? 0)
  }, [spring, value])

  if (value === null) return <span>{empty}</span>

  return <motion.span>{display}</motion.span>
}
